

export const PublishMessageAddToProject =  (msg) => {
    //console.log("EZ msg : ",msg)
    const eventData= {
        "fn": "EZAddToProject",
        "data": msg,
        "IsValid": true
       }
      
    window.parent.postMessage(eventData,'*')  
}

export const PublishMessageClose =  () => {
    const eventData= {
        "fn": "cnsClose",
        "data": "",
        "IsValid": true
       }

    window.parent.postMessage(eventData,'*')  
}